import { render } from "./Inset.vue?vue&type=template&id=9337967e&scoped=true&ts=true"
import script from "./Inset.vue?vue&type=script&lang=ts"
export * from "./Inset.vue?vue&type=script&lang=ts"

import "./Inset.vue?vue&type=style&index=0&id=9337967e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9337967e"]])

export default __exports__